/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Dashboard } from '../../models/dashboard';

export interface GetDashboard$Params {
}

export function getDashboard(http: HttpClient, rootUrl: string, params?: GetDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<Dashboard>> {
  const rb = new RequestBuilder(rootUrl, getDashboard.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Dashboard>;
    })
  );
}

getDashboard.PATH = '/api/v1/dashboard';
